import React, { useEffect, useState, useRef } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import logo from "../assets/images/omsagalogo-removebg-preview.webp";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../config/Config";
import { useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from 'sweetalert2';
import { Button, Modal } from "react-bootstrap";
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faXmark, faBars, faHandshake, faAward, faCircleCheck, faCubes, faClipboardCheck } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [popupmessage, setpopupmessage] = useState("");

  const [open, setOpen] = useState(false);

   const toggleDrawer = (state) => {
    setOpen(state);
  };

  const popupmessageRef = useRef("");
  popupmessageRef.current = popupmessage;
  // console.log("header customerdata >>", customerdata);

  const logoutfunc = async() => {
    var data = {
      password: ""
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + customerdata?.token,
      },
    };
    let resp = await axios
          .post(apiUrl + "userlogout",data, headers)
          .then((res) => {
            // console.log('getdashboarddata res >>', res.data)
            if(res?.data?.status == 'success') {
              dispatch({ type: "customerdata", payload: {} });
            } else {
              
            }
          })
          .catch((err) => {
            alert(err.message);

          });
    console.log('data >>', data);
  }

  const handlelogout = () => {
    dispatch({ type: "customerdata", payload: {} });
    logoutfunc();
    navigate("/");
  }

  const handlecheckforpopup = async() => {
    if(customerdata && Object.keys(customerdata)?.length > 0) {
      console.log('handlecheckforpopup customerdata >>', customerdata);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + customerdata?.token,
        },
      };
      var data = {
        password: ""
      }
      let resp = await axios
          .post(apiUrl + "checkuser",data, headers)
          .then((res) => {
            // console.log('getdashboarddata res >>', res.data)
            if(res?.data?.status == 'success') {
              var prevdata = res?.data?.data;
              if(prevdata['show_notification'] == "true") {
                setShowModal(true);
                setpopupmessage(prevdata['message']);

              } else {
                setShowModal(false);
                setpopupmessage("");
              }
            } else {
              if (res.data.message == "invalid user") {
                dispatch({ type: "customerdata", payload: {} });
                navigate("/login");
              } else {
                Swal.fire({
                  title: "",
                  text: res.data.message,
                  icon: "error",
                  customClass: {
                    icon: "custom-swal-icon", // Apply the custom class
                  },
                  width: "350px",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                    popup: "small-icon-alert",
                  },
                });
              }
            }
          })
          .catch((err) => {
            alert(err.message);

          });
    } else {
      
    }
  }

  const CKEditorOutput = ({ content }) => {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  const handleclosepopup = async() => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + customerdata?.token,
      },
    };
    var data = {
      password: ""
    }
    let resp = await axios
        .post(apiUrl + "user-close-popup",data, headers)
        .then((res) => {
          // console.log('getdashboarddata res >>', res.data)
          if(res?.data?.status == 'success') {
            setShowModal(false);
            setpopupmessage("");
          } else {
            if (res.data.message == "invalid user") {
              dispatch({ type: "customerdata", payload: {} });
              navigate("/login");
            } else {
              Swal.fire({
                title: "",
                text: res.data.message,
                icon: "error",
                customClass: {
                  icon: "custom-swal-icon", // Apply the custom class
                },
                width: "350px",
                confirmButtonText: "Ok",
                confirmButtonColor: "rgb(59, 151, 196)",
                customClass: {
                  popup: "small-icon-alert",
                },
              });
            }
          }
        })
        .catch((err) => {
          alert(err.message);

        });
  }

  useEffect(() => {
    handlecheckforpopup();
  }, [])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or 'auto' if you want instant scroll
    });
    setOpen(false)
  }, [pathname]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg  sticky-navbar ">
        <div className="container">
          {/* Brand */}
          <Link className="navbar-brand" to="/">
            <img
              src={logo}
              alt="Logo"
              className="nav-logo"
              loading="eager" // This tells the browser to load it immediately
              decoding="async"
            />
          </Link>

          {/* Toggle Button */}
          <button
            className="navbar-toggler"
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarNav"
            // aria-controls="navbarNav"
            // aria-expanded="false"
            // aria-label="Toggle navigation"
            onClick={() => {
              setOpen(true);
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div className="collapse navbar-collapse " id="navbarNav">
            <ul className="navbar-nav  mx-auto">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/aboutus">
                  About Us
                </Link>
              </li>
<li className="nav-item dropdown">
  <Link
    className="nav-link dropdown-toggle"
    to="#"
    id="storyCreatorDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Story Creator
  </Link>

  <ul
    className="dropdown-menu"
    aria-labelledby="storyCreatorDropdown"
  >
    <li>
      <Link className="dropdown-item" to="/createstory">
        Life Stories (Adult)
      </Link>
    </li>

    <li>
      <Link className="dropdown-item" to="/kidsstory">
        Young Voices (Kids)
      </Link>
    </li>
  </ul>
</li>
<li className="nav-item">
                <Link className="nav-link" to="/stories">
                  Soul Tales
                </Link>
              </li>
                 <li className="nav-item">
                <Link className="nav-link" to="/gallery">
                Gallery
                </Link>
              </li>
               <li className="nav-item">
                <Link className="nav-link" to="/contribute">
                Contribution
                </Link>
              </li>
              

                 {/* <li className="nav-item">
                <Link className="nav-link" to="/createstory">
                 Story Creator
                </Link>
              </li> */}
              {/* <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/createstory"
                  id="servicesDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                    
                </Link>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="servicesDropdown"
                >
                
                
                </ul>
              </li> */}

              <li className="nav-item">
                <Link className="nav-link" to="/contactus">
                  Contact
                </Link>
              </li>

   {/* Modal */}
   {/* {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <p className="popup-modal-box-head">
            <CKEditorOutput
                        content={popupmessageRef?.current}
                      />
            </p>
            

            <button className="popup-modal-box-close" onClick={() => {
              handleclosepopup()
            }}>
              Close
            </button>

           
          </div>
        </div>
      )} */}

{showModal && (
  <Modal
  show={showModal}
  // onHide={() => setShowModal(false)}
  size={"md"}
  className=" home-header-modal"
>
  <Modal.Body>
  <div className="modal-overlay">
          <div className="modal-box">
            <button onClick={() => handleclosepopup()}  className="popup-modal-box-close">
              <X size={20} />
            </button>
            <p className="popup-modal-box-head">
            <CKEditorOutput
                        content={popupmessageRef?.current}
                      />
            </p>
          </div>
        </div>
    </Modal.Body>
    </Modal>
       
      )}
    


            </ul>

            <ul className="navbar-nav ms-auto">
           {customerdata && Object.keys(customerdata).length > 0 ? (
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="servicesDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Hi {customerdata?.fullname}
                  </Link>
                  <ul
                    className="dropdown-menu profile-dropdown"
                    aria-labelledby="servicesDropdown"
                  >
                    <li>
                      <div className="dropdown-item enrolldiv" onClick={() => {navigate('/allstory')}}>
                        My Stories
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-item enrolldiv" onClick={() => {handlelogout()}}>
                        Logout
                      </div>
                    </li>
                  </ul>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    className="nav-link "
                    to="/login"
                  >
                    <User size={18} /> {/* user icon */}
                    Login
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <Drawer
            anchor="right"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 250 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/aboutus">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/gallery"
                  onClick={() => toggleDrawer(false)}
                >
                  Gallery
                </Link>
              </li>
               <li className="nav-item">
                <Link className="nav-link" to="/contribute">
                Contribution
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/stories">
                  Soul Tales
                </Link>
              </li>

              <li className="nav-item dropdown">
  <Link
    className="nav-link dropdown-toggle"
    to="#"
    id="mobileStoryCreatorDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Story Creator
  </Link>

  <ul
    className="dropdown-menu"
    aria-labelledby="mobileStoryCreatorDropdown"
  >
    <li>
      <Link
        className="dropdown-item"
        to="/createstory"
        onClick={() => toggleDrawer(false)}
      >
       Life Stories
      </Link>
    </li>

    <li>
      <Link
        className="dropdown-item"
        to="/kidsstory"
        onClick={() => toggleDrawer(false)}
      >
        Young Voices
      </Link>
    </li>
  </ul>
</li>
              

              <li className="nav-item">
                <Link className="nav-link" to="/contactus">
                  Contact
                </Link>
              </li>
    


            </ul>


            <ul className="navbar-nav">
           {customerdata && Object.keys(customerdata).length > 0 ? (
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="servicesDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Hi {customerdata?.fullname}
                  </Link>
                  <ul
                    className="dropdown-menu profile-dropdown"
                    aria-labelledby="servicesDropdown"
                  >
                    <li>
                      <div className="dropdown-item enrolldiv" onClick={() => {navigate('/allstory')}}>
                        My Stories
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-item enrolldiv" onClick={() => {handlelogout()}}>
                        Logout
                      </div>
                    </li>
                  </ul>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    className="nav-link "
                    to="/login"
                  >
                    <User size={18} /> {/* user icon */}
                    Login
                  </Link>
                </li>
              )}
            </ul>
                </nav>
                
              </div>
              {/* {['Dashboard', 'Profile', 'Settings', 'Logout'].map((text) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))} */}
            </List>
          </Drawer>
    </div>
  );
};

export default Header;
